<script>
  import { fade } from 'svelte/transition'
  import { cubicOut } from 'svelte/easing';
  import { modals } from '../stores'
  import { createEventDispatcher } from 'svelte'
  
  export let flush_header = false
  export let id
  export let is_visible = false
  export let preview_is_content = false
  export let persistent = false
  export let medium = false
  export let large = false
  export let buy = false
  
  const dispatch = createEventDispatcher()

  modals.register(id, persistent)
  const toggleVisibility = () => is_visible = modals.isVisible(id)
  $: $modals && toggleVisibility()

  function handleKeydown(event) {
    if (event.keyCode === 27) {
      close()
    }
  }
  function close() {
    dispatch('modalClosed')
    if (modals.isVisible(id)) modals.close()
  }
</script>

<svelte:window on:keydown={handleKeydown}/>

{#if is_visible}
  <div 
  class="modal" 
  class:medium
  class:large
  class:buy
  class:has_preview={$$slots.preview}
  class:has_content_in_preview={preview_is_content} 
  transition:fade="{{duration: 500, easing: cubicOut}}">
    <div class="fader" on:click={close}></div>
    <div class="window">
      <div class="body">
        <div class="header" class:flush_header>
          <h2>
            <slot name="header">Modal header</slot>
          </h2>
        </div>
        {#if $$slots.content}
          <div class="content">
            <slot name="content">Modal content</slot>
          </div>
        {/if}
        {#if $$slots.footer}
          <div class="footer">
            <slot name="footer">Modal footer</slot>
          </div>
        {/if}
        {#if $$slots.banner}
          <div class="banner">
            <slot name="banner">Banner content here</slot>
          </div>
        {/if}
      </div>
      {#if $$slots.preview}
        <div class="preview_window" class:preview_is_content>
          <slot name="preview">Window content here</slot>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
.modal {
  z-index: 9;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
}
.modal .fader {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--c-bg);
  opacity: 0.94;
}
.modal .window {
  position: relative;
  z-index: 10;
  max-width: 120rem;
  max-height: calc(100vh - 8rem);
  background-color: var(--c-bg);
  box-shadow: var(--box-shadow);
}

.modal.large .window {
  max-width: 360rem;
}

/* Focus Trapping */
.modal .window:not(:focus-within) {
  transition: opacity 0.1ms;
  opacity: 0.999;
}

/* Modal Body */
.modal .window .body {
  width: 36rem;
  padding: 3rem;
  background-color: var(--c-nav-bg);
}
.modal.medium .window .body {
  width: 54rem;
}
.modal.large .window .body {
  width: 96rem;
}

.modal .window .body .header {
  padding-bottom: 3rem;
}
.modal .window .body .header.flush_header {
  background-color: var(--c-pill-bg);
  margin: -3rem -3rem -4rem;
  padding: 3rem 3rem 6rem;
}
:global(.dark_theme) .modal .window .body .header.flush_header{
  background-color: var(--c-flash-onboarding-bg);
}

.modal .window .body .banner {
  margin: 3rem -3rem -3rem;
  padding: 2rem 3rem;
  background-color: var(--c-accent-fill);
  color: var(--c-text-on-fill);
}

/* Modal Preview */
.modal.has_preview .window {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: Calc(100vw - 12rem);
}
.modal.has_preview .preview_window {
  flex: 1;
}
.modal .window .preview_window {
  position: relative;
  padding: 3rem;
  overflow-y: scroll;
  border-left: 2px solid var(--c-bg);
  background-color: var(--c-nav-bg);
  background-image: linear-gradient(45deg, var(--c-content-bg) 25%, transparent 25%, transparent 75%, var(--c-content-bg) 75%, var(--c-content-bg)),linear-gradient(45deg, var(--c-content-bg) 25%, transparent 25%, transparent 75%, var(--c-content-bg) 75%, var(--c-content-bg));
  background-size: 2rem 2rem;
  background-position: 0 0, 1rem 1rem;
}
.modal .window .preview_window.preview_is_content {
  background-color: var(--c-content-bg);
  border-left: 0;
  overflow-y: scroll;
}

/* Modal scrollable content in preview */
.modal.has_content_in_preview .window,
.modal.has_content_in_preview .window .preview_window {
  height: 100%;
}
.modal.has_content_in_preview .window {
  overflow: hidden;
  max-height: calc(100vh - 4rem);
}

/* Modal Buy */
.modal.buy {
  overflow: scroll;
  align-items: unset;
}

.modal.buy .fader {
  position: fixed;
}

.modal.buy .header.flush_header {
  padding: 3rem !important;
}

.modal.buy .window {
  max-width: calc(100vw - 12rem);
  max-height: unset;
  margin-top: 4rem;
}

.modal.buy .window .body {
  width: calc(100vw - 12rem);
  background-color: var(--c-content-bg);
}

.modal.buy .window .body .header.flush_header {
  padding: 3rem 3rem 5rem;
  margin-bottom: 0;
  background-color: var(--c-nav-bg);
  border-bottom: 2px solid var(--c-bg);
}

@media only screen and (max-width: 820px) {
  .modal:not(.buy) .window {
    overflow: scroll !important;
  }
  .window {
    max-width: calc(100vw -  6rem) !important;
    margin-top: 3rem !important;
  }
  .body {
    width: 100% !important;
  }
  .preview_window {
    height: auto !important;
  }
}

</style>